import { useSelector, useStore, useDispatch } from "react-redux";
import { useEffect } from "react";
import * as theme from "../theme";
import {
  getCurrentNode,
  getFormsOrder,
  getFormState,
  getPermanentCodes,
  getProspectDoc,
} from "../store/qf";
import EachFormNavTab from "./EachFormNavTab";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  Client_Address,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import AutoFitTextDiv from "./AutoFitTextDiv";
import NormalText from "./NormalText";
import { getOperationListProspectDoc } from "../store/businesslogic/hardwiredlogic";
import { getLanguageCode } from "../store/components";
import { getAddressInFormattedForm } from "../store/businesslogic/hwlHelper";
import { useLocation } from "react-router";
import { getCHSdata, getChsDataStatus, filterFormsOrder } from "../store/qf";
import { getBrokerInformation } from "../store/broker";
import { useNavigate } from "react-router-dom";

const QFNavigation = () => {
  const { search } = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const infoHeight = "23%";
  const navhght = `calc(100% - ${infoHeight})`;
  const formsorder = useSelector(getFormsOrder);
  const formstate = useSelector(getFormState);
  const permanentcodes = useSelector(getPermanentCodes);
  const currentnode = useSelector(getCurrentNode);
  const prospectdoc = useSelector(getProspectDoc);
  // const languagecode = useSelector(getLanguageCode);
  const brokerInfo = useSelector(getBrokerInformation);
  const languagecode = brokerInfo?.information?.languagepreference || "en";
  const query = new URLSearchParams(search);
  useEffect(() => {
    dispatch(filterFormsOrder(query.get("show")));
  }, []);
  // let [client_info_nodes, setClientInfoNodes] = useState({
  //   client_name_node: null,
  //   client_phone_node: null,
  //   client_address_node: null,
  //   client_email_node: null,
  // });
  const getAnswerValue = ({ node }) => {
    try {
      if (node.type === "address") {
        return getAddressInFormattedForm({
          node: formstate[node.formid].nodestate[node.id],
        });
      }
      return formstate[node.formid].nodestate[node.id].answer;
    } catch (error) {
      return null;
    }
  };

  const getFirstOperationName = ({ prospectdoc }) => {
    const operationlist = getOperationListProspectDoc(prospectdoc);
    try {
      if(operationlist[0]?.vertical?.name?.[languagecode]){
        return operationlist[0].vertical.name[languagecode];
      }
      else if(prospectdoc?.otherdetails?.triagedata?.coverage?.[0]?.name){
        return prospectdoc.otherdetails.triagedata.coverage[0].name[languagecode]
      }
    } catch (e) {
      return "";
    }
  };

  // useEffect(() => {
  //   console.log("FORMSTATE CHANGED", formstatecopy.a.nodestate[10101].answer);
  //   return () => {};
  // }, [formstatecopy]);

  return (
    <div
      style={{
        ...theme.fwfh,
        display: "flex",
        flexDirection: "column",
        fontFamily: "GibsonRegular",
      }}
    >
      <div
        style={{
          width: "100%",
          height: infoHeight,
          padding: "10%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
        }}
      >
        <div
          style={{
            width: "100%",
            height: "50%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              fontFamily: "GibsonSemiBd",
              letterSpacing: 1,
              color: theme.COLORS.primary_navyblue,
              fontSize: "1.9vmin",
              cursor:"pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              if(prospectdoc.otherdetails?.customerid){
                navigate(`/customer?id=${prospectdoc.otherdetails?.customerid}`);
              }
              else {
                console.log("Prospect not attached to customer")
              }
            }}
          >
            {getAnswerValue({ node: permanentcodes[Client_Name] })}
          </div>
          <div
            style={{
              width: "100%",
              fontFamily: "GibsonLight",
              letterSpacing: 1,
              fontSize: "1.3vmin",
              color: "grey",
              lineHeight: 1.3,
            }}
          >
            {getFirstOperationName({ prospectdoc })}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: "50%",
            display: "flex",
            fontSize: "1.3vmin",
            color: "grey",
            fontFamily: "GibsonLight",
            paddingTop: "1vmin",
          }}
        >
          <div
            style={{
              width: "50%",
              height: "100%",
              display: "flex",
              overflow: "auto",
              paddingRight: "1vmin",
              lineHeight: 1.3,
            }}
          >
            <PerfectScrollbar>
              {getAnswerValue({ node: permanentcodes[Client_Address] })}
            </PerfectScrollbar>
          </div>

          <div
            style={{
              width: "50%",
              height: "100%",
              display: "flex",
              overflow: "hidden",
              flexDirection: "column",
              lineHeight: 1.3,
            }}
          >
            <PerfectScrollbar>
              {getAnswerValue({ node: permanentcodes[Client_Contact] })}
              <br />
              {getAnswerValue({ node: permanentcodes[Client_Email] })}
            </PerfectScrollbar>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: navhght,
          backgroundColor: theme.COLORS.primary_navyblue,
          color: "white",
          letterSpacing: 1,
        }}
      >
        <PerfectScrollbar>
          {formsorder.map((formid) => (
            <EachFormNavTab
              key={formid}
              formid={formid}
              currentnode={currentnode}
            ></EachFormNavTab>
          ))}
        </PerfectScrollbar>
      </div>
    </div>
  );
};

export default QFNavigation;
